// src/App.js
import React from 'react';
import NavTabs from './components/NavTabs';
import SetupPage from './pages/SetupPage';
import LabelingPage from './pages/LabelingPage';
import WorkReviewPage from './pages/WorkReviewPage';
import InsightPage from './pages/InsightPage';
import VisualizationPage from './pages/VisualizationPage';
import PivotPage from './pages/PivotPage';
import PivotRefactoredPage from './pages/PivotRefactoredPage';
import BatchEditPage from './pages/BatchEditPage';
import BatchLabelingPage from './pages/BatchLabelingPage';
import ClusterPage from './pages/ClusterPage';
import HomePage from './pages/HomePage';
import { ProjectProvider } from './context/ProjectContext'; // Import ProjectProvider
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <ProjectProvider> {/* Wrap entire app in ProjectProvider */}
          <Router>
            <NavTabs />
            <Routes>
              <Route path="/home" element={<HomePage />} />
              <Route path="/setup" element={<SetupPage />} />
              <Route path="/labeling" element={<LabelingPage />} />
              <Route path="/review" element={<WorkReviewPage />} />
              <Route path="/insight" element={<InsightPage />} />
              <Route path="/visualization" element={<VisualizationPage />} />
              {/* <Route path="/pivot" element={<PivotPage />} /> */}
              <Route path="/pivot" element={<PivotRefactoredPage />} />
              <Route path="/" element={<HomePage />} />
              <Route path="/batch" element={<BatchEditPage />} />
              <Route path="/batch-labeling" element={<BatchLabelingPage />} />
              {/*<Route path="/cluster" element={<ClusterPage />} />*/}
            </Routes>
          </Router>
        </ProjectProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
